import { render, staticRenderFns } from "./TextFieldDimensions.vue?vue&type=template&id=65546f56&"
import script from "./TextFieldDimensions.vue?vue&type=script&lang=js&"
export * from "./TextFieldDimensions.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldDimensions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VTextField})
